import React from 'react';
import { StyledMaterialUILink, StyledReactRouterLink } from './styles';
import { ICustomTheme } from 'interfaces';
import { useMediaQuery, useTheme } from '@material-ui/core';

type TProps = {
  children?: React.ReactNode;
  textLink?: string;
  url: string;
  isInternalLink: boolean;
  color?: string;
  withUnderline?: boolean;
  fontWeight?: string;
  target?: string;
  onClick?: () => void;
};

export const LinkWithUIGuidelines = ({
  children,
  textLink,
  url,
  isInternalLink,
  color,
  withUnderline,
  fontWeight,
  target,
  onClick,
}: TProps) => {
  const theme: ICustomTheme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'), { noSsr: true });

  return (
    <>
      {isInternalLink ? (
        <StyledReactRouterLink
          to={url}
          onClick={onClick}
          isMobile={isMobile}
          color={color}
          fontWeight={fontWeight}
          withUnderline={withUnderline}
        >
          {children || textLink}
        </StyledReactRouterLink>
      ) : (
        <StyledMaterialUILink
          href={url}
          onClick={onClick}
          target={target || '_blank'}
          rel={'noopener noreferrer'}
          isMobile={isMobile}
          color={'primary'}
          fontWeight={fontWeight}
          withUnderline={withUnderline}
        >
          {children || textLink}
        </StyledMaterialUILink>
      )}
    </>
  );
};
